import Dialog from "../../../../components/Dialog";
import { StyledFilterData } from "../../../../styles/pages/AdministratorTach/FilterTachStyles";
import FilterData from "../../Filter/FilterData";
import HeaderGenerateTach from "./HeaderGenerateTach";
import ActionGenerateTach from "./ActionGenerateTach";
import { useFilterData } from "../../../../context/TachContext/FilterDataContext";

export interface IModalGenerateTach {
    isOpen: boolean;
    onHide: () => void;
}

const ModalGenerateTach: React.FC<IModalGenerateTach> = ({
    isOpen,
    onHide,
}) => {
    const { filterGenerate, handleResetFilter } = useFilterData();

    const handleClose = () => {
        handleResetFilter(false);
        onHide();
    };

    const dialogClass = `${
        filterGenerate.openModal ? "hidden-dialog" : "visible-dialog"
    }`;

    return (
        <Dialog
            openModal={isOpen}
            onHide={() => handleClose()}
            className={dialogClass}
            size="width-600 modal-radius-8"
        >
            <div style={{ padding: "20px" }}>
                <HeaderGenerateTach />
                <StyledFilterData>
                    <FilterData isGenerate />
                </StyledFilterData>
                <ActionGenerateTach handleClose={handleClose} />
            </div>
        </Dialog>
    );
};

export default ModalGenerateTach;
